"use client";

import { useRef, useEffect, useState } from "react";
import Slider, { Settings } from "react-slick";
import Image from "next/image";
import arrowLeft from "../../lib/carousel/arrow_left.png";
import arrowRight from "../../lib/carousel/arrow_right.png";
const styles = new Proxy({"Wrapper":"Wrapper-b0ac3","Solutions":"Solutions-b0ac3","CardRow":"CardRow-b0ac3","CarouselWrap":"CarouselWrap-b0ac3","SlideOuter":"SlideOuter-b0ac3","ListItem":"ListItem-b0ac3","Controls":"Controls-b0ac3","Dots":"Dots-b0ac3","Dot":"Dot-b0ac3","DotActive":"DotActive-b0ac3","ArrowBtn":"ArrowBtn-b0ac3","InnerRow":"InnerRow-b0ac3","ListItemInner":"ListItemInner-b0ac3","IconWrapper":"IconWrapper-b0ac3","Subtext":"Subtext-b0ac3","Title":"Title-b0ac3"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./SolutionsSlider.scss";*/
import { LoadedListItemGroup } from "./types";

export default function SolutionsCarousel({ lists }: { lists: LoadedListItemGroup[] }) {
  const sliderRef = useRef<Slider>(null);
  const [active, setActive] = useState(false);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const check = () => setActive(window.innerWidth < 992);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  if (!active) return null;

  const SETTINGS: Settings = {
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    speed: 300,
    cssEase: "ease",
    afterChange: (index) => setCurrent(index),
  };

  return (
    <div className={styles.CarouselWrap}>
      <Slider ref={sliderRef} {...SETTINGS} className="SolutionsSlider">
        {lists.map((list, idx) => (
          <div key={idx} className={styles.SlideOuter}>
            <div className={styles.ListItem}>
              <div className="d-flex flex-column align-items-center">
                <div className="pb-4">
                  <h3>{list.title}</h3>
                </div>
                <div className={`d-md-flex w-100 justify-content-between ${styles.InnerRow}`}>
                  <div className={styles.ListItemInner}>
                    {list.itemsLeft.map((item, i) => (
                      <div
                        key={item.name || i}
                        className="d-flex w-100 justify-content-between align-items-center mb-4"
                      >
                        <p className="my-0">{item.name}</p>
                        {item.image?.url && (
                          <div className={styles.IconWrapper}>
                            <Image
                              src={item.image.url}
                              alt={item.altText}
                              fill
                              sizes="48px"
                              style={{ objectFit: "contain" }}
                            />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className={styles.ListItemInner}>
                    {list.itemsRight.map((item, i) => (
                      <div
                        key={item.name || i}
                        className="d-flex w-100 justify-content-between align-items-center mb-4"
                      >
                        <p className="my-0">{item.name}</p>
                        {item.image?.url && (
                          <div className={styles.IconWrapper}>
                            <Image
                              src={item.image.url}
                              alt={item.altText}
                              fill
                              sizes="48px"
                              style={{ objectFit: "contain" }}
                            />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
      <div className={styles.Controls}>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickPrev()}
          aria-label="Previous"
        >
          <Image src={arrowLeft} alt="Previous" width={20} height={29} />
        </button>
        <ul className={styles.Dots}>
          {lists.map((_, i) => (
            <li
              key={i}
              className={i === current % lists.length ? styles.DotActive : styles.Dot}
              onClick={() => sliderRef.current?.slickGoTo(i)}
            />
          ))}
        </ul>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickNext()}
          aria-label="Next"
        >
          <Image src={arrowRight} alt="Next" width={20} height={29} />
        </button>
      </div>
    </div>
  );
}
